<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> BlackList</h3>
      </div>
    </div>
    <BlackListList ref="BlackListList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import BlackListList from './components/list/BlackListList.vue'

export default {
  name: 'BlackList',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    BlackListList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.BlackListAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blacklist/BlackList/blacklist.vue